import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

// components
import ManualFertilityPlanFertilizerInputs from 'planting-plan-form/ManualFertilityPlanFertilizerInputs';
import FertilityActivityCategories from 'planting-plan-form/FertilityActivityCategories';

var baseString = 'vra-manual-fertility-plan-form-inputs';
var classString = classNames({
  [`${baseString}`]: true,
  'vra-planting-plan-form-inputs': true
});
const ManualFertilityPlanFormInputs = ({
  disabled,
  fertilityActivities,
  fertilityActivityCategories,
  hasSubstanceType,
  isAppMode,
  maxDate,
  minDate,
  onSelectDate,
  onChangeNitrapyrin,
  onChangePlantingFertilizerApplication,
  onSelectSubstanceType,
  onSelectFertilityActivityCategory,
  plantingPlanParams,
  substanceTypeIsNitrogen,
  substanceTypes,
  validationResult
}) => {
  const { activityCategoryUuid } = plantingPlanParams;
  return (
    <section className={classString}>
      <FertilityActivityCategories
        disabled={disabled}
        fertilityActivities={fertilityActivities}
        fertilityActivityCategories={fertilityActivityCategories}
        onSelectFertilityActivityCategory={onSelectFertilityActivityCategory}
        plantingPlanParams={plantingPlanParams}
      />
      <ManualFertilityPlanFertilizerInputs
        disabled={disabled}
        hasSubstanceType={hasSubstanceType}
        isAppMode={isAppMode}
        isVisible={!!activityCategoryUuid}
        maxDate={maxDate}
        minDate={minDate}
        onChangeNitrapyrin={onChangeNitrapyrin}
        onChangePlantingFertilizerApplication={onChangePlantingFertilizerApplication}
        onSelectDate={onSelectDate}
        onSelectSubstanceType={onSelectSubstanceType}
        plantingPlanParams={plantingPlanParams}
        substanceTypeIsNitrogen={substanceTypeIsNitrogen}
        substanceTypes={substanceTypes}
        validationResult={validationResult}
      />
    </section>
  );
};
ManualFertilityPlanFormInputs.propTypes = {
  disabled: propTypes.bool,
  fertilityActivities: propTypes.object.isRequired,
  fertilityActivityCategories: propTypes.array.isRequired,
  hasSubstanceType: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onChangeNitrapyrin: propTypes.func.isRequired,
  onChangePlantingFertilizerApplication: propTypes.func.isRequired,
  onSelectDate: propTypes.func.isRequired,
  onSelectFertilityActivityCategory: propTypes.func.isRequired,
  onSelectIncorporationMethod: propTypes.func.isRequired,
  onSelectSubstanceType: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  substanceTypeIsNitrogen: propTypes.bool.isRequired,
  substanceTypes: propTypes.object.isRequired,
  validationResult: propTypes.object
};
export default ManualFertilityPlanFormInputs;
